import React from 'react';
import AdminDashboard from '../../components/admin/AdminDashboard';

/**
 * AdminDashboardPage - Main admin dashboard page
 * Accessible at /admin/dashboard
 * Provides system administrators with overview of platform metrics and quick actions
 */
const AdminDashboardPage: React.FC = () => {
  return <AdminDashboard />;
};

export default AdminDashboardPage; 